/* eslint-disable react/jsx-props-no-spreading */
import React, { memo, useMemo } from 'react';
import AvatarMC from '../../../components/AvatarMC';
import PLATFORM_CONFIG from '../../../utils/platformConfig';
import STATUS_CHAT_MAP from '../../../utils/statusChatMap';

/**
 * ConversationAvatarMC - Specialized Avatar Component (Molecule Level)
 *
 * Avatar especializado para conversaciones del inbox que combina AvatarMC base
 * con indicador de plataforma social en la esquina inferior derecha.
 */
const ConversationAvatarMC = memo(({ ticketStatus, statusChat, platform }) => {
  // Configuración de plataforma memoizada (icono de red social)
  const platformIcon = useMemo(() => PLATFORM_CONFIG[platform], [platform]);

  // Nombre completo memoizado para AvatarMC (solo ticketStatus)
  const fullName = useMemo(() => ticketStatus || 'U', [ticketStatus]);

  // Clases CSS optimizadas basadas en el estado del chat
  const avatarClasses = useMemo(() => {
    const colorClass = STATUS_CHAT_MAP[statusChat]?.classNameAvatarMC || 'tw-bg-green-100 tw-text-green-600';
    return {
      // Clases personalizadas para AvatarMC
      avatarContainer: `tw-w-8 tw-h-8 tw-text-xs tw-font-medium ${colorClass}`,
      initials: 'tw-text-xs tw-font-medium'
    };
  }, [statusChat]);

  // Props memoizadas para AvatarMC para evitar re-renders
  const avatarProps = useMemo(() => ({
    fullName,
    avatarClassName: avatarClasses.avatarContainer,
    initialsClassName: avatarClasses.initials,
    className: "tw-relative"
  }), [fullName, avatarClasses.avatarContainer, avatarClasses.initials]);

  // Props memoizadas para la imagen de plataforma
  const platformImageProps = useMemo(() => {
    if (!platformIcon) return null;
    return {
      src: platformIcon.src,
      alt: `${platformIcon.alt} - ${platform}`,
      className: "tw-w-3 tw-h-3"
    };
  }, [platformIcon, platform]);

  return (
    <div className="tw-flex-shrink-0 tw-relative">
      <AvatarMC {...avatarProps} />
      {platformImageProps && (
        <div className="tw-absolute tw-bottom-0 tw-right-0 tw-translate-x-1/6 tw-translate-y-1/6 tw-z-10">
          <img {...platformImageProps} />
        </div>
      )}
    </div>
  );
});

ConversationAvatarMC.displayName = 'ConversationAvatarMC';

export default ConversationAvatarMC;
